module.exports = __webpack_public_path__ + "img/pk-monitoring.5e533a90.png";